import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../../css/permission/ManagePermissionsAdit.css";
import "../../css/Manage.css";
import ManagerApi from "../../api/managerApi";
import { toast } from "react-toastify";

const ManagePermissionsAdit = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [access, setAccess] = useState([0]);
  const [managerId, setManagerId] = useState(0);
  const [managerData, setManagerData] = useState({});

  useEffect(() => {
    if (location.state) {
      const { id } = location.state;
      setManagerId(location.state.id);
      getManagerInfo(id);
    }
  }, [location]);

  const getManagerInfo = async (id) => {
    try {
      const info = (await ManagerApi.Get(id)).data.data.content;
      setManagerData((managerData) => info);
      let modifiedString = info.accessMenu.replace(/([a-zA-Z-]+)/g, '"$1"');
      let accessTemp = JSON.parse(modifiedString);
      setAccess((access) => accessTemp);
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  const checkHandler = (str) => {
    let copyData = [...access];
    if (copyData.includes(str)) {
      let index = copyData.indexOf(str);
      access.splice(index, 1);
      copyData.splice(index, 1);
      const string = `[${copyData.join(", ")}]`;
      setManagerData({
        ...managerData,
        accessMenu: string,
      });
    } else {
      access.push(str);
      copyData.push(str);
      const string = `[${copyData.join(", ")}]`;
      setManagerData({
        ...managerData,
        accessMenu: string,
      });
    }
  };

  const editHandler = async () => {
    let changeData = {
      email: managerData.email,
      name: managerData.name,
      managerAuthority: managerData.managerAuthority,
      accessMenu: managerData.accessMenu,
    };
    try {
      await ManagerApi.Patch(managerId, changeData);
      toast("저장되었습니다.");
      navigate(-1);
    } catch (err) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div
          className="go-back"
          onClick={() => {
            navigate(-1);
          }}
        >
          <Link>
            <img src="\img\chevron-left.svg" />
            <span>뒤로가기</span>
          </Link>
        </div>
        <div className="Manage-form manage-form-peradit">
          <p>수정하기</p>

          <div className="Manage-input-container">
            <p className="manage-permissions-adit-title">이메일</p>
            <input
              type="email"
              className="manage-permissions-adit-input"
              value={managerData.email}
              onChange={(e) => {
                setManagerData({
                  ...managerData,
                  email: e.target.value,
                });
              }}
            />
          </div>
          <div className="Manage-input-container">
            <p className="manage-permissions-adit-title">비밀번호</p>
            <input
              type="password"
              className="manage-permissions-adit-input"
              disabled
            />
          </div>
          <div className="Manage-input-container">
            <p className="manage-permissions-adit-title">비밀번호 확인</p>
            <input
              type="password"
              className="manage-permissions-adit-input"
              disabled
            />
          </div>
          <div className="manage-permissions-adit-radio">
            <span className="manage-permissions-adit-title">권한</span>
            <div>
              {managerData.managerAuthority === "ROOTADMIN" ? (
                <>
                  <input
                    className="cursorPointer"
                    type="radio"
                    name="right"
                    id="root1"
                    value="ROOTADMIN"
                    checked={
                      managerData.managerAuthority === "ROOTADMIN" ? true : null
                    }
                    onChange={(e) => {
                      setManagerData({
                        ...managerData,
                        managerAuthority: e.target.value,
                      });
                    }}
                  />
                  <label htmlFor="root1">ROOT</label>
                </>
              ) : null}
              {managerData.managerAuthority === "ROOTADMIN" ? null : (
                <>
                  <input
                    className="cursorPointer"
                    type="radio"
                    name="right"
                    id="admin1"
                    value="ADMIN"
                    checked={
                      managerData.managerAuthority === "ADMIN" ? true : null
                    }
                    onChange={(e) => {
                      setManagerData({
                        ...managerData,
                        managerAuthority: e.target.value,
                      });
                    }}
                  />
                  <label htmlFor="admin1">ADMIN</label>
                  <input
                    className="cursorPointer"
                    type="radio"
                    name="right"
                    id="manager1"
                    value="MANAGER"
                    checked={
                      managerData.managerAuthority === "MANAGER" ? true : null
                    }
                    onChange={(e) => {
                      setManagerData({
                        ...managerData,
                        managerAuthority: e.target.value,
                        accessMenu: "[space-member, meeting, program, mileage]",
                      });
                    }}
                  />
                  <label htmlFor="manager1">MANAGER</label>
                </>
              )}
              <span>
                *ROOT일 경우 아래 접근권한 설정에 관계없이 모든 메뉴 접근이
                가능합니다.
              </span>
            </div>
          </div>

          {managerData.managerAuthority === "MANAGER" ? (
            <div className="manage-permissions-approval-checkbox manage-permissions-approval-access-right">
              <span className="manage-permissions-approval-title">
                접근 권한
              </span>
              <div className="manage-permissions-approval-access-right-container">
                <div className="user-management">
                  <span>사용자 관리</span>
                  <input
                    type="checkbox"
                    name="user-management"
                    id="space-member"
                    checked={access.includes("space-member") ? true : null}
                    readOnly
                  />
                  <label htmlFor="space-member">공간회원 관리</label>
                </div>
                <div>
                  <span>운영 관리</span>
                  <input
                    type="checkbox"
                    name="operation-management"
                    id="meeting"
                    checked={access.includes("meeting") ? true : null}
                    readOnly
                  />
                  <label htmlFor="meeting">모임 관리</label>
                  <input
                    type="checkbox"
                    name="operation-management"
                    id="program"
                    checked={access.includes("program") ? true : null}
                    readOnly
                  />
                  <label htmlFor="program">프로그램 관리</label>
                  <input
                    type="checkbox"
                    name="operation-management"
                    id="mileage"
                    checked={access.includes("mileage") ? true : null}
                    readOnly
                  />
                  <label htmlFor="mileage">마을리지 관리</label>
                </div>
              </div>
            </div>
          ) : (
            <div className="manage-permissions-adit-checkbox manage-permissions-adit-access-right">
              <span className="manage-permissions-adit-title">접근 권한</span>
              <div className="access-right-container">
                <div className="user-management">
                  <span>사용자 관리</span>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="member"
                    value="member"
                    name="user-management"
                    checked={access.includes("member") ? true : null}
                    onChange={() => checkHandler("member")}
                  />
                  <label htmlFor="member">일반회원 관리</label>

                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="withdraw-member"
                    name="user-management"
                    value="leave-member"
                    checked={access.includes("leave-member") ? true : null}
                    onChange={() => checkHandler("leave-member")}
                  />
                  <label htmlFor="withdraw-member">탈퇴회원 관리</label>
                </div>
                <div className="operation-management">
                  <span>운영 관리</span>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="meeting"
                    value="meeting"
                    name="operation-management"
                    checked={access.includes("meeting") ? true : null}
                    onChange={() => checkHandler("meeting")}
                  />
                  <label htmlFor="meeting">모임 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="meeting-member"
                    value="meeting-member"
                    name="operation-management"
                    checked={access.includes("meeting-member") ? true : null}
                    onChange={() => checkHandler("meeting-member")}
                  />
                  <label htmlFor="meeting-member">모임 결제 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="program"
                    value="program"
                    name="operation-management"
                    checked={access.includes("program") ? true : null}
                    onChange={() => checkHandler("program")}
                  />
                  <label htmlFor="program">프로그램 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="mileage"
                    value="mileage"
                    name="operation-management"
                    checked={access.includes("mileage") ? true : null}
                    onChange={() => checkHandler("mileage")}
                  />
                  <label htmlFor="mileage">마을리지 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="accomodation"
                    value="accomodation"
                    name="operation-management"
                    checked={access.includes("accomodation") ? true : null}
                    onChange={() => checkHandler("accomodation")}
                  />
                  <label htmlFor="accomodation">숙소 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="residency"
                    value="residency"
                    name="user-management"
                    checked={access.includes("residency") ? true : null}
                    onChange={() => checkHandler("residency")}
                  />
                  <label htmlFor="residency">거주권 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="residency-price"
                    value="residency-price"
                    name="user-management"
                    checked={access.includes("residency-price") ? true : null}
                    onChange={() => checkHandler("residency-price")}
                  />
                  <label htmlFor="residency-price">거주권 가격 관리</label>
                  {/* <input
                    className="cursorPointer"
                    type="checkbox"
                    id="space-member"
                    value="space-member"
                    name="user-management"
                    checked={access.includes("space-member") ? true : null}
                    onChange={() => checkHandler("space-member")}
                  /> */}
                  {/* <label htmlFor="space-member">공간회원 관리</label> */}
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="space"
                    name="user-management"
                    value="space"
                    checked={access.includes("space") ? true : null}
                    onChange={() => checkHandler("space")}
                  />
                  <label htmlFor="space">공간 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="space-support"
                    name="user-management"
                    value="space-support"
                    checked={access.includes("space-support") ? true : null}
                    onChange={() => checkHandler("space-support")}
                  />
                  <label htmlFor="space-support">공간 지원 관리</label>
                </div>
                <div className="community-management">
                  <span>커뮤니티 관리</span>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="comunity"
                    value="comunity"
                    name="community-management"
                    checked={access.includes("comunity") ? true : null}
                    onChange={() => checkHandler("comunity")}
                  />
                  <label htmlFor="comunity">커뮤니티 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="call"
                    value="call"
                    name="community-management"
                    checked={access.includes("call") ? true : null}
                    onChange={() => checkHandler("call")}
                  />
                  <label htmlFor="call">신고 관리</label>
                </div>
                <div className="service-management service-manage-form">
                  <span>서비스 관리</span>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="alarm"
                    value="alarm"
                    checked={access.includes("alarm") ? true : null}
                    onChange={() => checkHandler("alarm")}
                  />
                  <label htmlFor="alarm">알림 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="coupon"
                    value="coupon"
                    name="service-management"
                    checked={access.includes("coupon") ? true : null}
                    onChange={() => checkHandler("coupon")}
                  />
                  <label htmlFor="coupon">쿠폰 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="coupon-usage-history"
                    value="coupon-usage-history"
                    name="service-management"
                    checked={access.includes("coupon-usage-history") ? true : null}
                    onChange={() => checkHandler("coupon-usage-history")}
                  />
                  <label htmlFor="coupon-usage-history">쿠폰 사용 내역</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="notice"
                    value="notice"
                    checked={access.includes("notice") ? true : null}
                    onChange={() => checkHandler("notice")}
                  />
                  <label htmlFor="notice">공지사항 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="faq"
                    value="faq"
                    checked={access.includes("faq") ? true : null}
                    onChange={() => checkHandler("faq")}
                  />
                  <label htmlFor="faq">FAQ 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="marker"
                    value="marker"
                    checked={access.includes("marker") ? true : null}
                    onChange={() => checkHandler("marker")}
                  />
                  <label htmlFor="marker">마커 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="popup"
                    value="popup"
                    checked={access.includes("popup") ? true : null}
                    onChange={() => checkHandler("popup")}
                  />
                  <label htmlFor="popup">팝업 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="terms"
                    value="terms"
                    checked={access.includes("terms") ? true : null}
                    onChange={() => checkHandler("terms")}
                  />
                  <label htmlFor="terms" style={{ marginRight: "20px" }}>
                    약관 관리
                  </label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="banner"
                    value="banner"
                    checked={access.includes("banner") ? true : null}
                    onChange={() => checkHandler("banner")}
                  />
                  <label htmlFor="banner">배너 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    name="service-management"
                    id="open-source"
                    value="open-source"
                    checked={access.includes("open-source") ? true : null}
                    onChange={() => checkHandler("open-source")}
                  />
                  <label htmlFor="open-source">오픈소스 관리</label>
                </div>
                <div>
                  <span>환경설정</span>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="base"
                    name="right"
                    value="base"
                    checked={access.includes("base") ? true : null}
                    onChange={() => checkHandler("base")}
                  />
                  <label htmlFor="base">기본정보 관리</label>
                  <input
                    className="cursorPointer"
                    type="checkbox"
                    id="manager"
                    name="right"
                    value="manager"
                    checked={access.includes("manager") ? true : null}
                    onChange={() => checkHandler("manager")}
                  />
                  <label htmlFor="manager">관리자 권한 관리</label>
                </div>
              </div>
            </div>
          )}
          <div className="Manage-form-save manage-form-save-peradit">
            <button className="cursorPointer" onClick={editHandler}>
              저장하기
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManagePermissionsAdit;
